<template>
  <div
    class="ts-aot-spinner"
    :style="spinnerStyles"
  >
    <img
      :src="aotIcon"
      alt="Loading"
    >
  </div>
</template>

<script>
import aotIcon from '@/assets/img/aot-icon.svg'

export default {
  name: 'ThunderLoader',
  props:{
    width: {
      type: String,
      default: '50%'
    },
    height: {
      type: String,
      default: '50%'
    }
  },
  data () {
    return {
      aotIcon,
    }
  },
  computed: {
    spinnerStyles () {
      return {
        width: this.width,
        height: this.height,
      }
    }
  }
}
</script>

<style scoped>
.ts-aot-spinner {
  margin-left: 25%;
  min-width: 64px;
  min-height: 64px;
  background: transparent;
}

.ts-aot-spinner img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* Pivot on the splat's centre of mass, not its bounding-box centre: the petals
     are heavier at the bottom, so the mass sits ~4px below the box centre and
     rotating about the box centre makes it orbit. 54% maps to that centroid
     (measured as the pivot that minimises rotational centroid drift). */
  transform-origin: 50% 54%;
  /* Hold still, then a single ease-in-out turn (speed rises then falls), then
     hold again before repeating. 360deg per turn so the resting orientation
     never jumps at the loop boundary. */
  animation: aot-spin 2s ease-in-out infinite;
}

@keyframes aot-spin {
  0%, 12% {
    transform: rotate(0deg);
  }
  88%, 100% {
    transform: rotate(360deg);
  }
}
</style>

<!--
  Centering inside a v-overlay (page/section data-loading usage). Vuetify 4
  anchors .v-overlay__content top-left and auto-sizes it to the slot, and the
  spinner's own percentage sizing + margin-left:25% collapse there, dropping the
  loader into the corner. Stretch the content to fill the (absolutely-positioned)
  overlay and centre the spinner, capping its size so the 50% default can't blow
  up on large overlays. Lives in a NON-scoped block because it targets the
  .v-overlay__content ancestor, which the consuming v-overlay adds outside this
  component's template; :has() keeps it limited to overlays holding a loader.
  The :not() excludes an overlay that only holds a *nested* loading overlay: a
  menu or dialog would otherwise match too, and `inset: 0 !important` cancels
  the inline top/left Vuetify computes for it, so the menu drifts further from
  its activator on every reposition.
-->
<style>
.v-overlay__content:has(.ts-aot-spinner):not(:has(.v-overlay__content)) {
  position: absolute !important;
  inset: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-overlay__content:has(.ts-aot-spinner):not(:has(.v-overlay__content)) .ts-aot-spinner {
  margin-left: 0;
  max-width: 160px;
  max-height: 160px;
}
</style>
